var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontalWhiteOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 908.96368,
    height: 137.28867,
    viewBox: "0 0 908.96367 137.28866",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-286.61301,-410.14191)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-308.14821,-417.09021)",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-359.30031,-390.66871)",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-405.52141,-408.56571)",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-455.29811,-445.61321)",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-510.16561,-408.56571)",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-596.70832,-456.36021)",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-640.10162,-404.52581)",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-685.99982,-463.71291)",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-737.47292,-417.09021)",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-785.31129,-445.61321)",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-833.8759,-406.46511)",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-880.01455,-463.71291)",
    id: "path26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-925.11482,-470.59211)",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-922.53122,-461.40501)",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-402.02661,-383.90951)",
    id: "path36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-417.37921,-385.19881)",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-431.62371,-375.66031)",
    id: "path40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-448.05931,-373.04871)",
    id: "path42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-460.93031,-375.90061)",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-476.65591,-385.19881)",
    id: "path46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-491.14781,-375.82621)",
    id: "path48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-510.64972,-384.53711)",
    id: "path50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-528.98602,-379.01611)",
    id: "path52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-537.12322,-373.91651)",
    id: "path54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-550.58231,-375.67741)",
    id: "path56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-572.82761,-379.01611)",
    id: "path58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-580.89661,-381.49601)",
    id: "path60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-591.02771,-373.48711)",
    id: "path62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-604.18192,-385.19881)",
    id: "path64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-627.19121,-375.67741)",
    id: "path68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-650.50162,-373.91651)",
    id: "path70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-664.39822,-381.49601)",
    id: "path72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-678.71801,-375.67741)",
    id: "path74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-709.26902,-384.53711)",
    id: "path76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-715.26522,-381.49601)",
    id: "path78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-735.55252,-379.01611)",
    id: "path80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-744.84802,-373.08991)",
    id: "path82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-759.20004,-373.04871)",
    id: "path84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-772.60892,-375.82621)",
    id: "path86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-790.12404,-381.49601)",
    id: "path90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-810.36115,-379.01611)",
    id: "path92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-828.23125,-373.20561)",
    id: "path94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-842.80922,-375.66031)",
    id: "path96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-857.97895,-373.91651)",
    id: "path98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-873.09842,-373.08991)",
    id: "path100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-886.2025,-385.19881)",
    id: "path102"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    id: "path104"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-908.87462,-381.49601)",
    id: "path106"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 1190.551 V 0 H 0 Z",
    transform: "translate(-923.19445,-375.90061)",
    id: "path108"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0",
    transform: "translate(-339.21866,-492.61589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 c 2.505,2.154 3.757,5.144 3.757,8.969 0,3.879 -1.279,6.881 -3.838,9.009 -2.558,2.128 -6.154,3.191 -10.787,3.191 h -18.18 V -3.232 h 18.583 c 4.472,0 7.96,1.077 10.465,3.232 m -1.332,27.15 c 2.368,2.046 3.554,4.874 3.554,8.484 0,3.608 -1.171,6.464 -3.515,8.564 -2.343,2.101 -5.616,3.152 -9.817,3.152 H -29.048 V 24.079 h 17.857 c 4.201,0 7.488,1.023 9.859,3.071 m -9.697,23.19 c 2.531,0 4.807,-0.337 6.828,-1.011 2.019,-0.673 3.744,-1.643 5.171,-2.909 1.427,-1.266 2.532,-2.787 3.312,-4.565 0.782,-1.777 1.173,-3.77 1.173,-5.979 0,-3.286 -0.836,-6.06 -2.505,-8.323 -1.67,-2.262 -4.04,-3.852 -7.112,-4.767 3.556,-0.916 6.303,-2.559 8.243,-4.929 1.938,-2.37 2.909,-5.36 2.909,-8.969 0,-4.687 -1.55,-8.377 -4.646,-11.07 -3.099,-2.693 -7.34,-4.04 -12.728,-4.04 H -32.199 V 50.34 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,382.15067,587.66413)",
    clipPath: "url(#clipPath2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 0,0 c 0.916,-2.316 2.197,-4.309 3.839,-5.979 1.643,-1.67 3.61,-2.962 5.898,-3.879 2.289,-0.915 4.809,-1.373 7.556,-1.373 2.747,0 5.264,0.458 7.554,1.373 2.29,0.917 4.255,2.209 5.899,3.879 1.643,1.67 2.921,3.663 3.838,5.979 0.916,2.317 1.373,4.875 1.373,7.676 0,2.802 -0.457,5.361 -1.373,7.677 -0.917,2.316 -2.195,4.296 -3.838,5.938 -1.644,1.644 -3.609,2.923 -5.899,3.839 -2.29,0.916 -4.807,1.373 -7.554,1.373 -2.747,0 -5.267,-0.457 -7.556,-1.373 C 7.449,24.214 5.482,22.935 3.839,21.291 2.197,19.649 0.916,17.669 0,15.353 -0.914,13.037 -1.374,10.478 -1.374,7.676 -1.374,4.875 -0.914,2.317 0,0 m 8.444,-12.564 c -2.667,1.05 -4.955,2.545 -6.868,4.484 -1.911,1.939 -3.394,4.242 -4.443,6.909 -1.051,2.666 -1.576,5.615 -1.576,8.847 0,3.232 0.525,6.182 1.576,8.848 1.049,2.667 2.532,4.97 4.443,6.909 1.913,1.94 4.201,3.434 6.868,4.485 2.666,1.05 5.616,1.575 8.849,1.575 3.231,0 6.181,-0.525 8.847,-1.575 2.666,-1.051 4.956,-2.545 6.868,-4.485 1.913,-1.939 3.394,-4.242 4.445,-6.909 1.051,-2.666 1.576,-5.616 1.576,-8.848 0,-3.232 -0.525,-6.181 -1.576,-8.847 -1.051,-2.667 -2.532,-4.97 -4.445,-6.909 -1.912,-1.939 -4.202,-3.434 -6.868,-4.484 -2.666,-1.051 -5.616,-1.576 -8.847,-1.576 -3.233,0 -6.183,0.525 -8.849,1.576",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,410.86427,578.39973)",
    clipPath: "url(#clipPath4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 0,0 c 1.508,0 2.786,0.094 3.837,0.282 1.051,0.189 1.967,0.553 2.747,1.092 0.782,0.537 1.469,1.252 2.061,2.14 0.593,0.889 1.212,2.061 1.859,3.515 l 2.747,6.707 -19.878,41.209 h 3.394 L 14.786,17.372 30.542,54.945 h 3.233 L 13.251,5.817 C 12.55,4.094 11.809,2.666 11.029,1.535 10.248,0.403 9.358,-0.485 8.363,-1.131 7.366,-1.778 6.22,-2.236 4.927,-2.505 3.635,-2.775 2.073,-2.909 0.242,-2.909 H -3.072 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,479.06707,613.6284)",
    clipPath: "url(#clipPath6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 0,0 c 2.207,-1.696 5.225,-2.545 9.05,-2.545 2.585,0 4.983,0.377 7.19,1.131 2.209,0.754 4.121,1.818 5.738,3.192 1.616,1.373 2.867,2.99 3.757,4.848 0.889,1.858 1.334,3.865 1.334,6.02 v 3.313 H 7.676 C 4.39,15.959 1.738,15.151 -0.283,13.534 -2.304,11.919 -3.314,9.737 -3.314,6.99 -3.314,4.026 -2.209,1.697 0,0 m -2.263,-2.06 c -2.747,2.208 -4.12,5.198 -4.12,8.969 0,3.608 1.278,6.491 3.837,8.645 2.559,2.156 5.939,3.232 10.142,3.232 h 19.473 v 4.04 c 0,1.832 -0.337,3.502 -1.012,5.01 -0.672,1.509 -1.628,2.802 -2.867,3.879 -1.239,1.077 -2.72,1.912 -4.445,2.505 -1.723,0.592 -3.609,0.889 -5.655,0.889 -3.502,0 -6.518,-0.835 -9.05,-2.505 -2.532,-1.67 -4.255,-3.959 -5.171,-6.868 h -3.153 c 1.024,3.824 3.072,6.828 6.142,9.009 3.071,2.181 6.787,3.273 11.151,3.273 2.532,0 4.834,-0.364 6.909,-1.092 2.073,-0.727 3.878,-1.763 5.413,-3.11 1.535,-1.347 2.72,-2.936 3.556,-4.768 0.834,-1.831 1.252,-3.851 1.252,-6.059 V -4.646 H 27.472 L 27.23,3.757 c -1.725,-2.854 -4.189,-5.09 -7.393,-6.706 -3.206,-1.616 -6.828,-2.424 -10.868,-2.424 -4.741,0 -8.485,1.104 -11.232,3.313",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,540.6952,589.76573)",
    clipPath: "url(#clipPath8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 0,0 0.242,-9.777 c 1.454,3.448 3.651,6.101 6.586,7.96 2.935,1.858 6.262,2.787 9.979,2.787 2.693,0 5.117,-0.458 7.273,-1.373 2.153,-0.917 3.998,-2.236 5.533,-3.96 1.537,-1.724 2.708,-3.797 3.517,-6.222 0.806,-2.424 1.212,-5.144 1.212,-8.16 V -41.693 H 31.27 v 22.786 c 0,5.225 -1.332,9.346 -3.999,12.362 -2.666,3.017 -6.263,4.525 -10.787,4.525 -2.37,0 -4.538,-0.43 -6.505,-1.293 C 8.013,-4.174 6.315,-5.387 4.888,-6.948 3.461,-8.511 2.356,-10.37 1.576,-12.524 0.794,-14.678 0.403,-17.076 0.403,-19.715 V -41.693 H -2.666 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,607.06413,540.36907)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 0,0 c 2.207,-1.696 5.225,-2.545 9.05,-2.545 2.585,0 4.983,0.377 7.19,1.131 2.209,0.754 4.121,1.818 5.738,3.192 1.616,1.373 2.867,2.99 3.757,4.848 0.889,1.858 1.334,3.865 1.334,6.02 v 3.313 H 7.676 c -3.287,0 -5.938,-0.808 -7.959,-2.425 C -2.304,11.919 -3.314,9.737 -3.314,6.99 -3.314,4.026 -2.209,1.697 0,0 m -2.263,-2.06 c -2.747,2.208 -4.12,5.198 -4.12,8.969 0,3.608 1.278,6.491 3.837,8.645 2.559,2.156 5.939,3.232 10.142,3.232 h 19.473 v 4.04 c 0,1.832 -0.337,3.502 -1.012,5.01 -0.672,1.509 -1.628,2.802 -2.867,3.879 -1.239,1.077 -2.72,1.912 -4.445,2.505 -1.723,0.592 -3.609,0.889 -5.655,0.889 -3.502,0 -6.518,-0.835 -9.05,-2.505 -2.532,-1.67 -4.255,-3.959 -5.171,-6.868 h -3.153 c 1.024,3.824 3.072,6.828 6.142,9.009 3.069,2.181 6.787,3.273 11.151,3.273 2.532,0 4.834,-0.364 6.909,-1.092 2.073,-0.727 3.878,-1.763 5.413,-3.11 1.535,-1.347 2.72,-2.936 3.556,-4.768 0.834,-1.831 1.252,-3.851 1.252,-6.059 V -4.646 H 27.472 L 27.23,3.757 c -1.725,-2.854 -4.189,-5.09 -7.393,-6.706 -3.206,-1.616 -6.828,-2.424 -10.868,-2.424 -4.741,0 -8.485,1.104 -11.232,3.313",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,680.2208,589.76573)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 0,0 -14.14,-34.179 H 14.221 Z M 1.616,4.121 25.211,-52.44 h -3.394 l -6.384,15.272 h -30.786 l -6.383,-15.272 h -3.393 L -1.535,4.121 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,795.61107,526.03973)",
    clipPath: "url(#clipPath14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 0,0 c -2.586,1.051 -4.809,2.545 -6.667,4.485 -1.857,1.939 -3.299,4.241 -4.323,6.908 -1.024,2.667 -1.535,5.616 -1.535,8.848 0,3.232 0.511,6.181 1.535,8.848 1.024,2.666 2.466,4.956 4.323,6.868 1.858,1.913 4.081,3.407 6.667,4.485 2.586,1.077 5.44,1.615 8.564,1.615 4.848,0 9.077,-1.279 12.686,-3.838 3.61,-2.559 6.115,-6.019 7.515,-10.383 h -3.152 c -1.508,3.61 -3.73,6.384 -6.665,8.323 -2.935,1.939 -6.398,2.908 -10.384,2.908 -2.693,0 -5.145,-0.457 -7.352,-1.373 -2.209,-0.915 -4.108,-2.195 -5.697,-3.838 -1.59,-1.643 -2.815,-3.622 -3.677,-5.939 -0.861,-2.316 -1.293,-4.875 -1.293,-7.676 0,-2.801 0.432,-5.36 1.293,-7.677 C -7.3,10.249 -6.075,8.255 -4.485,6.585 -2.896,4.916 -0.997,3.623 1.212,2.707 3.419,1.791 5.871,1.333 8.564,1.333 c 4.203,0 7.825,1.078 10.868,3.232 3.045,2.155 5.186,5.091 6.425,8.808 h 3.231 C 27.687,8.632 25.182,4.956 21.573,2.344 17.965,-0.269 13.628,-1.576 8.564,-1.576 5.44,-1.576 2.586,-1.051 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,853.4688,595.15227)",
    clipPath: "url(#clipPath16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 0,0 v -27.553 c 1.508,3.34 3.717,5.912 6.626,7.717 2.91,1.804 6.222,2.706 9.939,2.706 2.693,0 5.117,-0.458 7.273,-1.373 2.153,-0.916 3.971,-2.223 5.452,-3.919 1.483,-1.697 2.627,-3.757 3.436,-6.182 0.807,-2.424 1.212,-5.144 1.212,-8.16 v -23.029 h -3.071 v 22.867 c 0,5.279 -1.293,9.4 -3.879,12.362 -2.586,2.963 -6.168,4.444 -10.746,4.444 -2.37,0 -4.553,-0.416 -6.545,-1.252 -1.994,-0.835 -3.704,-2.02 -5.132,-3.555 C 3.138,-26.462 2.021,-28.32 1.212,-30.503 0.405,-32.684 0,-35.095 0,-37.734 V -59.793 H -3.07 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,914.6664,516.23613)",
    clipPath: "url(#clipPath18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 0,0 c 0.916,-2.316 2.197,-4.309 3.839,-5.979 1.643,-1.67 3.61,-2.962 5.898,-3.879 2.289,-0.915 4.809,-1.373 7.556,-1.373 2.747,0 5.264,0.458 7.554,1.373 2.29,0.917 4.255,2.209 5.899,3.879 1.643,1.67 2.921,3.663 3.838,5.979 0.916,2.317 1.373,4.875 1.373,7.676 0,2.802 -0.457,5.361 -1.373,7.677 -0.917,2.316 -2.195,4.296 -3.838,5.938 -1.644,1.644 -3.609,2.923 -5.899,3.839 -2.29,0.916 -4.807,1.373 -7.554,1.373 -2.747,0 -5.267,-0.457 -7.556,-1.373 C 7.449,24.214 5.482,22.935 3.839,21.291 2.197,19.649 0.916,17.669 0,15.353 -0.914,13.037 -1.374,10.478 -1.374,7.676 -1.374,4.875 -0.914,2.317 0,0 m 8.444,-12.564 c -2.667,1.05 -4.955,2.545 -6.868,4.484 -1.911,1.939 -3.394,4.242 -4.443,6.909 -1.051,2.666 -1.576,5.615 -1.576,8.847 0,3.232 0.525,6.182 1.576,8.848 1.049,2.667 2.532,4.97 4.443,6.909 1.913,1.94 4.201,3.434 6.868,4.485 2.666,1.05 5.616,1.575 8.849,1.575 3.231,0 6.181,-0.525 8.847,-1.575 2.666,-1.051 4.956,-2.545 6.868,-4.485 1.913,-1.939 3.394,-4.242 4.445,-6.909 1.051,-2.666 1.576,-5.616 1.576,-8.848 0,-3.232 -0.525,-6.181 -1.576,-8.847 -1.051,-2.667 -2.532,-4.97 -4.445,-6.909 -1.912,-1.939 -4.202,-3.434 -6.868,-4.484 -2.666,-1.051 -5.616,-1.576 -8.847,-1.576 -3.233,0 -6.183,0.525 -8.849,1.576",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,983.2972,578.39973)",
    clipPath: "url(#clipPath20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M 0,0 17.13,-37.734 25.776,-18.422 34.261,0 h 3.312 L 18.584,-41.693 H 15.595 L -3.314,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1047.0817,540.36907)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 0,0 c -2.962,2.344 -4.578,5.562 -4.849,9.656 h 2.991 C -1.589,6.37 -0.256,3.825 2.141,2.02 4.538,0.215 7.918,-0.687 12.283,-0.687 c 4.04,0 7.217,0.754 9.534,2.262 2.316,1.509 3.475,3.556 3.475,6.142 0,2.424 -1.092,4.404 -3.273,5.938 -2.182,1.535 -5.669,2.707 -10.464,3.515 -5.387,0.97 -9.333,2.411 -11.838,4.323 -2.505,1.912 -3.757,4.431 -3.757,7.555 0,3.394 1.374,6.087 4.121,8.08 2.747,1.993 6.518,2.99 11.312,2.99 4.795,0 8.606,-1.064 11.433,-3.192 2.828,-2.127 4.404,-5.184 4.727,-9.17 h -2.989 c -0.269,3.124 -1.549,5.494 -3.837,7.11 -2.29,1.616 -5.401,2.424 -9.334,2.424 -3.878,0 -6.921,-0.741 -9.13,-2.222 -2.209,-1.481 -3.314,-3.515 -3.314,-6.1 0,-2.317 1.065,-4.189 3.192,-5.616 2.128,-1.428 5.616,-2.599 10.465,-3.515 10.504,-1.993 15.756,-6.034 15.756,-12.12 0,-3.448 -1.442,-6.182 -4.324,-8.202 -2.881,-2.02 -6.801,-3.03 -11.755,-3.03 C 7.058,-3.515 2.962,-2.344 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1111.8345,592.56653)",
    clipPath: "url(#clipPath24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 0,0 v -37.088 h 6.869 c 2.1,0 3.933,0.148 5.495,0.445 1.561,0.296 2.908,0.808 4.039,1.535 1.132,0.727 2.129,1.697 2.99,2.909 0.862,1.212 1.671,2.734 2.424,4.565 l 3.798,9.534 h 3.233 l -4.203,-10.746 c -0.915,-2.37 -1.98,-4.296 -3.192,-5.777 -1.212,-1.481 -2.652,-2.653 -4.322,-3.515 l 13.816,-21.655 h -3.636 l -13.09,20.605 c -1.992,-0.539 -4.497,-0.808 -7.513,-0.808 H 0 V -59.793 H -3.07 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1173.3527,516.23613)",
    clipPath: "url(#clipPath26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 926.56,403.92 h -3.07 v 41.693 h 3.07 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1134.52)",
    clipPath: "url(#clipPath28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 0,0 c -5.066,0 -9.188,-4.121 -9.188,-9.187 0,-5.066 4.122,-9.187 9.188,-9.187 5.066,0 9.186,4.121 9.186,9.187 C 9.186,-4.121 5.066,0 0,0 m 0,-20.21 c -6.079,0 -11.024,4.945 -11.024,11.023 0,6.078 4.945,11.023 11.024,11.023 6.077,0 11.022,-4.945 11.022,-11.023 C 11.022,-15.265 6.077,-20.21 0,-20.21",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1233.4864,507.06387)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "M 0,0 C 0,1.427 1.157,2.583 2.583,2.583 4.01,2.583 5.167,1.427 5.167,0 5.167,-1.427 4.01,-2.583 2.583,-2.583 1.157,-2.583 0,-1.427 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1230.0416,519.31333)",
    clipPath: "url(#clipPath34)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontalWhiteOnly);
export default __webpack_public_path__ + "static/media/logo-horizontal-white-only.1b29c1411cadeede3e55fafb705733e3.svg";
export { ForwardRef as ReactComponent };